export const SET_STEP = "SET_STEP";
export const SET_BACK_CONTROL_VISIBLE = "SET_BACK_CONTROL_VISIBLE";
export const SET_NEXT_CONTROL_DISABLE = "SET_NEXT_CONTROL_DISABLE";

export const setStep = (step) => ({
  type: SET_STEP,
  payload: { step },
});

export const setBackControlVisible = (hideBackControl) => ({
  type: SET_BACK_CONTROL_VISIBLE,
  payload: { hideBackControl },
});

export const setDisableNextControl = (disableNextControl) => ({
  type: SET_NEXT_CONTROL_DISABLE,
  payload: { disableNextControl },
});
